(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // SkillFoot — filtre instantané des cartes par nom de pays
  (function () {
    function normalize(str) {
      return (str || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
    }

    function initCollectionSearch() {
      const wrapper = document.querySelector('[data-sf-collection-search]');
      if (!wrapper) return;
      const input = wrapper.querySelector('[data-sf-search-input]');
      const clearBtn = wrapper.querySelector('[data-sf-search-clear]');
      const emptyMsg = wrapper.querySelector('[data-sf-search-empty]');
      const grid = document.querySelector('results-list');
      if (!input || !grid) return;

      function apply() {
        const query = normalize(input.value);
        const cards = grid.querySelectorAll('[data-sf-search-title]');
        let visible = 0;
        cards.forEach(function (card) {
          const title = normalize(card.getAttribute('data-sf-search-title'));
          const match = query === '' || title.indexOf(query) !== -1;
          card.hidden = !match;
          if (match) visible++;
        });
        if (clearBtn) clearBtn.hidden = query === '';
        if (emptyMsg) emptyMsg.hidden = !(query !== '' && visible === 0);
      }

      input.addEventListener('input', apply);
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          apply();
          input.focus();
        });
      }

      // Réappliquer le filtre quand l'infinite scroll ajoute des cartes
      const observer = new MutationObserver(function () {
        if (normalize(input.value) !== '') apply();
      });
      observer.observe(grid, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCollectionSearch, { once: true });
    } else {
      initCollectionSearch();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skillfoot-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCountdowns() {
      var hosts = document.querySelectorAll('.sf-col-hero[data-sf-kickoff]');
      hosts.forEach(function (host) {
        var target = new Date(host.getAttribute('data-sf-kickoff')).getTime();
        if (isNaN(target)) return;
        var els = {
          days: host.querySelector('[data-sf-cd="days"]'),
          hours: host.querySelector('[data-sf-cd="hours"]'),
          mins: host.querySelector('[data-sf-cd="mins"]'),
          secs: host.querySelector('[data-sf-cd="secs"]')
        };
        if (!els.days) return;
        // Coup d'envoi passé au chargement → masquer le compte à rebours (évite le « 0 jour 00:00:00 » figé)
        if (target - Date.now() <= 0) {
          var boardEl = host.querySelector('[data-sf-countdown]');
          if (boardEl) boardEl.style.display = 'none';
          return;
        }
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var tick = function () {
          var diff = target - Date.now();
          if (diff <= 0) {
            var b = host.querySelector('[data-sf-countdown]');
            if (b) b.style.display = 'none';
            if (host.__sfCdTimer) clearInterval(host.__sfCdTimer);
            return;
          }
          var s = Math.floor(diff / 1000);
          var d = Math.floor(s / 86400);
          els.days.textContent = d;
          var dayLabel = els.days.parentNode.querySelector('i');
          if (dayLabel) dayLabel.textContent = d > 1 ? 'jours' : 'jour';
          els.hours.textContent = pad(Math.floor((s % 86400) / 3600));
          els.mins.textContent = pad(Math.floor((s % 3600) / 60));
          els.secs.textContent = pad(s % 60);
        };
        tick();
        if (host.__sfCdTimer) clearInterval(host.__sfCdTimer);
        host.__sfCdTimer = setInterval(tick, 1000);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCountdowns);
    } else {
      initCountdowns();
    }
    document.addEventListener('shopify:section:load', initCountdowns);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skillfoot-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  // Custom element idempotent : init unique par instance, autoplay + dots + flèches + swipe + pause hover + reduced-motion.
  class SfHeroCarousel extends HTMLElement {
    connectedCallback() {
      if (this._init) {
        // Re-connexion (déplacement DOM / theme editor) : ré-attache les
        // listeners globaux retirés au disconnect, puis relance l'autoplay.
        if (this._onWinMove) window.addEventListener('mousemove', this._onWinMove);
        if (this._onWinUp) window.addEventListener('mouseup', this._onWinUp);
        if (this._onVisibility) document.addEventListener('visibilitychange', this._onVisibility);
        if (this._onBlockSelect) document.addEventListener('shopify:block:select', this._onBlockSelect);
        if (this._onBlockDeselect) document.addEventListener('shopify:block:deselect', this._onBlockDeselect);
        this.start();
        return;
      }
      this._init = true;

      this.track = this.querySelector('[data-sf-hc-track]');
      this.viewport = this.querySelector('[data-sf-hc-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-sf-hc-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-sf-hc-dot]'));
      this.count = this.slides.length;
      this.index = 0;
      this.timer = null;

      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reduced) this.classList.add('sf-hc--reduced');

      if (!this.track || this.count <= 1) return;

      this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
      this.speed = parseInt(this.dataset.speed, 10) || 6000;

      // Flèches
      const prev = this.querySelector('[data-sf-hc-prev]');
      const next = this.querySelector('[data-sf-hc-next]');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });

      // Dots
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(parseInt(dot.dataset.sfHcDot, 10));
          this.restart();
        });
      });

      // Clavier (gauche/droite) quand le carousel a le focus
      this.setAttribute('tabindex', '-1');
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { this.go(this.index - 1); this.restart(); }
        else if (e.key === 'ArrowRight') { this.go(this.index + 1); this.restart(); }
      });

      // Swipe tactile + drag souris
      this.startX = 0; this.deltaX = 0; this.dragging = false;
      const onStart = (x) => { this.dragging = true; this.startX = x; this.deltaX = 0; this.stop(); };
      const onMove = (x) => { if (this.dragging) this.deltaX = x - this.startX; };
      const onEnd = () => {
        if (!this.dragging) return;
        this.dragging = false;
        const threshold = Math.max(40, this.viewport.offsetWidth * 0.12);
        if (this.deltaX <= -threshold) this.go(this.index + 1);
        else if (this.deltaX >= threshold) this.go(this.index - 1);
        this.restart();
      };
      this.viewport.addEventListener('touchstart', (e) => onStart(e.touches[0].clientX), { passive: true });
      this.viewport.addEventListener('touchmove', (e) => onMove(e.touches[0].clientX), { passive: true });
      this.viewport.addEventListener('touchend', onEnd);
      this.viewport.addEventListener('mousedown', (e) => { onStart(e.clientX); e.preventDefault(); });
      // Listeners document/window stockés en propriétés → retirés dans disconnectedCallback (pas de fuite).
      this._onWinMove = (e) => onMove(e.clientX);
      this._onWinUp = onEnd;
      window.addEventListener('mousemove', this._onWinMove);
      window.addEventListener('mouseup', this._onWinUp);

      // Pause au hover / focus / onglet caché
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this._onVisibility = () => {
        if (document.hidden) this.stop(); else this.start();
      };
      document.addEventListener('visibilitychange', this._onVisibility);

      // Compat Theme Editor (Shopify) : aller à la slide d'un block sélectionné
      this._onBlockSelect = (e) => {
        if (!this.contains(e.target)) return;
        const i = this.slides.indexOf(e.target.closest('[data-sf-hc-slide]'));
        if (i >= 0) { this.go(i); this.stop(); }
      };
      this._onBlockDeselect = (e) => {
        if (this.contains(e.target)) this.start();
      };
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      document.addEventListener('shopify:block:deselect', this._onBlockDeselect);

      this.update();
      this.start();
    }

    go(i) {
      this.index = (i + this.count) % this.count;
      this.update();
    }

    update() {
      this.track.style.transform = 'translate3d(' + (-this.index * 100) + '%,0,0)';
      this.slides.forEach((s, i) => {
        // inert retire les CTA des slides masquées du tab order et de l'arbre d'accessibilité.
        const hidden = i !== this.index;
        if (hidden) s.setAttribute('aria-hidden', 'true');
        else s.removeAttribute('aria-hidden');
        s.toggleAttribute('inert', hidden);
      });
      this.dots.forEach((d, i) => {
        const active = i === this.index;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    start() {
      if (!this.autoplay || this.dragging || this.timer) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.speed);
    }

    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    restart() { this.stop(); this.start(); }

    disconnectedCallback() {
      this.stop();
      if (this._onWinMove) window.removeEventListener('mousemove', this._onWinMove);
      if (this._onWinUp) window.removeEventListener('mouseup', this._onWinUp);
      if (this._onVisibility) document.removeEventListener('visibilitychange', this._onVisibility);
      if (this._onBlockSelect) document.removeEventListener('shopify:block:select', this._onBlockSelect);
      if (this._onBlockDeselect) document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);
    }
  }

  if (!customElements.get('sf-hero-carousel')) {
    customElements.define('sf-hero-carousel', SfHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
